import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { WashingProcedure } from 'Components/Worksheets/WashWorksheet/types';
import React from 'react';
import { Field, RadioGroup, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import ids from '../../../QestIds';
import { WashingSectionContent } from './Sections';
import { ResultsSectionContent } from './Sections/ResultsSection';

const qestIds = [ids.wash.ASTM_C117.rev2017, ids.wash.AASHTO_T_11.rev2020];

let MeasuredWashAstmC117Worksheet: WorksheetRootComponent = () => (
  <>
    <ListFieldSection>
      <Field
        input={<RadioGroup />}
        label="Procedure"
        name="Preparation.WashingProcedure"
        options={[
          { label: 'A - Plain water', value: WashingProcedure.WashWithPlainWater },
          { label: 'B - With wetting agent', value: WashingProcedure.WashWithWaterAndAgent },
        ]}
      />
    </ListFieldSection>
    <ListFieldSection heading="Initial Material Dry Mass">
      <Field input={<TextOutput />} label="Tare Mass" name="Masses.InitialTareMass" />
      <Field input={<TextOutput />} label="Dry Mass" name="Masses.InitialDryMass" />
    </ListFieldSection>
    {/* Special section combining the content of the Washing and Results sections */}
    <ListFieldSection heading="Washing">
      <WashingSectionContent />
      <ResultsSectionContent />
    </ListFieldSection>
  </>
);

MeasuredWashAstmC117Worksheet.qestIds = qestIds;

export default MeasuredWashAstmC117Worksheet;
export { MeasuredWashAstmC117Worksheet };
